<template>
  <div>
    <!-- 自定义选择内容弹窗 -->
    <el-dialog
      title="添加内容"
      :visible="dialogShow"
      width="600px"
      :before-close="handleClose"
    >
      <el-input
        :placeholder="'请输入' + currentFloor.type + '名称'"
        v-model="dialogSearchName"
        class="input-with-select"
        size="small"
        @keyup.enter.native="searchContent()"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="searchContent()"
        ></el-button>
      </el-input>
      <el-table
        ref="contentTable"
        :data="dialogList"
        tooltip-effect="dark"
        style="width: 100%"
        :row-key="
          currentFloor.id !== 205
            ? 'documentId'
            : currentFloor.id !== 202
            ? 'albumId'
            : 'articleId'
        "
        :header-cell-style="{ color: '#333', 'font-size': '15px' }"
        @select="tableSelectionChange"
        @select-all="tableSelectionChange"
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="55"
        ></el-table-column>
        <el-table-column
          :label="currentFloor.type + '名称'"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.title }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        background
        :page-size="dialogPageSize"
        :current-page.sync="dialogPageIndex"
        :pager-count="5"
        layout="total, prev, pager, next, jumper"
        :total="dialogTotal"
        @current-change="currentChange"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">取 消</el-button>
        <el-button type="primary" @click="saveZDYContent()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/assets/js/api";
export default {
  name: "ShopCenterAdminWebMDiyDialog",

  data() {
    return {
      currentFloor: {
        id: 202,
        name: "文章", // 楼层名称
        type: "文章", // 楼层类型
        style: 1, // 1-缩略图 2-列表
        contentOrigin: 1, // 1-默认 2-自定义
        order: "pv$2", // 1-按总浏览排序 create_time-按创建时间排序
        count: 2, // 展示数量
        maxCount: 6, // 最大展示数量
        contentList: [], // 楼层内容列表
      },
      dialogPageIndex: 1, // 弹窗分页页码
      dialogPageSize: 5, // 弹窗分页每页数量
      dialogTotal: 0, // 弹窗数据总数
      dialogList: [], // 弹窗列表
      dialogSelectList: [], // 弹窗选中列表
      dialogSearchName: "", // 弹窗搜索名称
    };
  },
  computed: {
    dialogShow() {
      if (this.$store.state.mDecoration.dialogType == "diyContent") {
        return true;
      }
      return false;
    },
    shopId() {
      return this.$store.state.user.userInfo.shopId;
    },
  },
  watch: {
    "$store.state.mDecoration.dialogType": {
      async handler(newValue) {
        if (newValue == "diyContent") {
          // 清空选中效果
          this.$refs.contentTable && this.$refs.contentTable.clearSelection();
          // 获取当前楼层内容
          this.currentFloor = JSON.parse(
            JSON.stringify(this.$store.state.mDecoration.currentFloor)
          );
          // 自定义内容时 根据楼层默认排字段不同显示不同的数据
          if (this.currentFloor.id == 202 || this.currentFloor.id == 205) {
            this.currentFloor.order = "pv$2";
          } else if (
            this.currentFloor.id == 203 ||
            this.currentFloor.id == 204 ||
            this.currentFloor.id == 209
          ) {
            this.currentFloor.order = "downloads$2";
          }
          // 获取被选中的数据
          this.dialogSelectList = this.currentFloor.contentList;
          // 获取列表内容
          await this.searchContent();
        }
      },
      // immediate: true,
      deep: true,
    },
  },
  mounted() {},

  methods: {
    // 更新数据到vuex中
    updateVuex() {
      const list = JSON.parse(
        JSON.stringify(this.$store.state.mDecoration.floorList)
      );
      const index = list.findIndex((item) => item.key == this.currentFloor.key);
      list[index] = this.currentFloor;
      this.$store.commit("mDecoration/setFloorList", list);
      this.$store.commit("mDecoration/setCurrentFloor", this.currentFloor);
      this.closeDialog();
    },
    // 关闭弹窗操作
    closeDialog() {
      // 清除相关缓存数据
      this.dialogPageIndex = 1;
      this.dialogPageSize = 5;
      this.dialogTotal = 0;
      this.dialogList = [];
      this.dialogSelectList = [];
      this.dialogSearchName = "";
      // 更新数据到vuex中
      this.$store.commit("mDecoration/setDialogType", "");
    },
    // 关闭弹窗
    handleClose(done) {
      this.closeDialog();
      done();
    },
    // 保存自定义内容
    async saveZDYContent() {
      this.currentFloor.contentList = JSON.parse(
        JSON.stringify(this.dialogSelectList)
      );
      this.currentFloor.count = this.currentFloor.contentList.length;
      // 更新数据到vuex中
      this.updateVuex();
    },
    // 搜索自定义内容
    async searchContent() {
      if (this.currentFloor.id == 202) {
        await this.getArticleList();
      } else if (this.currentFloor.id == 203) {
        await this.getVideoList();
      } else if (this.currentFloor.id == 204) {
        await this.getResourceList();
      } else if (this.currentFloor.id == 205) {
        await this.getAlbumList();
      } else if (this.currentFloor.id == 209) {
        await this.getDiscountList();
      }
      this.$nextTick(() => {
        // 重新选中数据
        this.dialogSelectList.forEach((item) => {
          this.$refs.contentTable.toggleRowSelection(item, true);
        });
      });
    },
    // 选择自定义内容
    tableSelectionChange(selection) {
      if (selection.length <= this.currentFloor.maxCount) {
        this.dialogSelectList = selection;
      } else {
        this.$message({
          message: `当前楼层最多选择${this.currentFloor.maxCount}条数据`,
          type: "warning",
        });
        // 截取最大数量的数据
        this.dialogSelectList = selection.slice(0, this.currentFloor.maxCount);
        // 多余的数据取消选中
        selection.slice(this.currentFloor.maxCount).forEach((item) => {
          // 取消选中
          this.$refs.contentTable.toggleRowSelection(item, false);
        });
      }
    },

    // 选择自定义弹窗的分页
    async currentChange() {
      // 调用接口获取数据
      await this.searchContent();
      this.$nextTick(() => {
        // 重新选中数据
        this.dialogSelectList.forEach((item) => {
          this.$refs.contentTable.toggleRowSelection(item, true);
        });
      });
    },
    // 获取获取文章列表
    async getArticleList() {
      // 获取文章列表
      const res = await this.$axios.post(api.decoration.getArticleListEs, {
        shopId: Number(this.shopId),
        pageIndex: this.dialogPageIndex,
        pageSize: this.dialogPageSize,
        sortRule: "create_time$2",
        title: this.dialogSearchName,
      });

      this.dialogList = res.result.list || [];
      this.dialogTotal = res.result.totalCount;
      // 清空选中效果
      this.$refs.contentTable && this.$refs.contentTable.clearSelection();
      // 因为是引用类型，所以每次重新请求的数据虽然值相同 但地址不同
      // 所以每次请求新数据 需要将选中列表中原来的旧数据替换成新的数据
      // 这样才能确保取消选中效果方法能生效
      this.dialogList.forEach((item) => {
        const index = this.dialogSelectList.findIndex(
          (item2) => item2.articleId === item.articleId
        );
        if (index > -1) {
          this.dialogSelectList[index] = item;
        }
      });
    },
    // 获取视频列表
    async getVideoList() {
      const res = await this.$axios.post(
        api.decoration.getVideoOrResourceList,
        {
          shopId: Number(this.shopId),
          queryType: 2, // 1-资料 2-视频
          pageIndex: this.dialogPageIndex,
          pageSize: this.dialogPageSize,
          sortRule: "create_time$2",
          title: this.dialogSearchName,
        }
      );

      this.dialogList = res.list || [];
      this.dialogTotal = res.totalCount;
      // 清空选中效果
      this.$refs.contentTable && this.$refs.contentTable.clearSelection();
      // 因为是引用类型，所以每次重新请求的数据虽然值相同 但地址不同
      // 所以每次请求新数据 需要将选中列表中原来的旧数据替换成新的数据
      // 这样才能确保取消选中效果方法能生效
      this.dialogList.forEach((item) => {
        const index = this.dialogSelectList.findIndex(
          (item2) => item2.documentId === item.documentId
        );
        if (index > -1) {
          this.dialogSelectList[index] = item;
        }
      });
    },
    // 获取资料列表
    async getResourceList() {
      const res = await this.$axios.post(
        api.decoration.getVideoOrResourceList,
        {
          shopId: Number(this.shopId),
          queryType: 1, // 1-资料 2-视频
          pageIndex: this.dialogPageIndex,
          pageSize: this.dialogPageSize,
          sortRule: "create_time$2",
          title: this.dialogSearchName,
        }
      );
      this.dialogList = res.list || [];
      this.dialogTotal = res.totalCount;
      // 清空选中效果
      this.$refs.contentTable && this.$refs.contentTable.clearSelection();
      // 因为是引用类型，所以每次重新请求的数据虽然值相同 但地址不同
      // 所以每次请求新数据 需要将选中列表中原来的旧数据替换成新的数据
      // 这样才能确保取消选中效果方法能生效
      this.dialogList.forEach((item) => {
        const index = this.dialogSelectList.findIndex(
          (item2) => item2.documentId === item.documentId
        );
        if (index > -1) {
          this.dialogSelectList[index] = item;
        }
      });
    },
    // 获取折扣列表
    async getDiscountList() {
      const res = await this.$axios.post(
        api.decoration.getVideoOrResourceList,
        {
          activityState: 1, // 0-非活动 1-活动
          shopId: Number(this.shopId),
          queryType: this.currentFloor.style, // 1-资料 2-视频
          pageIndex: this.dialogPageIndex,
          pageSize: this.dialogPageSize,
          title: this.dialogSearchName,
        }
      );
      this.dialogList = res.list || [];
      this.dialogTotal = res.totalCount;
      // 清空选中效果
      this.$refs.contentTable && this.$refs.contentTable.clearSelection();
      // 因为是引用类型，所以每次重新请求的数据虽然值相同 但地址不同
      // 所以每次请求新数据 需要将选中列表中原来的旧数据替换成新的数据
      // 这样才能确保取消选中效果方法能生效
      this.dialogList.forEach((item) => {
        const index = this.dialogSelectList.findIndex(
          (item2) => item2.documentId === item.documentId
        );
        if (index > -1) {
          this.dialogSelectList[index] = item;
        }
      });
    },
    // 获取专辑列表
    async getAlbumList() {
      const res = await this.$axios.post(api.decoration.getAlbumList, {
        shopId: Number(this.shopId),
        pageIndex: this.dialogPageIndex,
        pageSize: this.dialogPageSize,
        sortRule: "create_time$2",
        title: this.dialogSearchName,
      });
      this.dialogList = res.list || [];
      this.dialogTotal = res.totalCount;
      // 清空选中效果
      this.$refs.contentTable && this.$refs.contentTable.clearSelection();
      // 因为是引用类型，所以每次重新请求的数据虽然值相同 但地址不同
      // 所以每次请求新数据 需要将选中列表中原来的旧数据替换成新的数据
      // 这样才能确保取消选中效果方法能生效
      this.dialogList.forEach((item) => {
        const index = this.dialogSelectList.findIndex(
          (item2) => item2.albumId === item.albumId
        );
        if (index > -1) {
          this.dialogSelectList[index] = item;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.input-with-select {
  margin-top: 6px;
  width: 50%;
}
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto 0;
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    margin: 0 40px;
  }
}

::v-deep .el-dialog__body {
  padding: 0 20px 20px;
}
::v-deep .el-table__header-wrapper .el-checkbox__inner {
  display: none !important;
}
</style>
